import { useState, useEffect } from "react";

export default function ClickToCopy({
  text,
  value = null,
  title = "",
  className = "",
  textClassName = "",
}: {
  text: string | number | undefined | null;
  value?: string | number | undefined | null;
  title?: string;
  className?: string;
  textClassName?: string;
}) {
  const [copied, setCopied] = useState(false);

  const toCopy = value ? value : text;

  const display =
    text != null && String(text) !== "" ? text : (value != null && value !== "" ? value : text);

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!toCopy) return;
    const str = toCopy.toString();
    if (!str) return;

    navigator.clipboard
      .writeText(str)
      .then(() => setCopied(true))
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  // hide bubble after 1s
  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 1000);
    return () => clearTimeout(t);
  }, [copied]);

  if (!text && !value) return null;

  const resolvedTitle = title
    ? `${title} (double-click to copy)`
    : "Double-click to copy";

  const show =
    display != null && String(display) !== "" ? String(display) : toCopy != null ? String(toCopy) : "";

  if (!show) return null;

  return (
    <span
      title={resolvedTitle}
      className={`relative inline-block max-w-full ${className}`}
      onClick={(e) => e.stopPropagation()}
      onDoubleClick={handleCopy}
    >
      {copied && (
        <div className="absolute -top-8 right-0 z-10 bg-gray-800 text-white text-xs rounded px-2 py-1 animate-fade-up">
          Copied!
        </div>
      )}

      <span
        className={`cursor-copy select-none border-b border-dotted border-transparent text-inherit decoration-transparent hover:border-slate-400 ${textClassName}`}
      >
        {show}
      </span>
    </span>
  );
}
